import React from 'react';
import MiniHeader from '../components/MiniHeader';
import DestinationDetails from '../components/DestinationDetails';

const DestinationDetail = () => {
  return (
    <>
    <MiniHeader title={"Destination Details"} />
    <DestinationDetails />
    </>
  );
};

export default DestinationDetail;